<template>
    <div>
        <progress-bar :items="counts" mode="multiple" :value="30"></progress-bar>

    </div>
</template>

<script>
import ProgressBar from "../../../primevue/progressbar/ProgressBar";

export default {
    name: "countPupilBar",
    components: {
        ProgressBar
    },
    props: {
        pupils: {
            type: Array,
            default: null
        },
        dataObj: {
            type: Array,
            default: null
        },
    },
    watch: {
        dataObj(newValue, oldValue) {

        }
    },
    methods: {
        getFinalCount(data) {
            // let firstLesson = data?.[Object.keys(data)[0]]
            if (data !== undefined) {
                // const firstLessonArray = Object.values(firstLesson)

                const finalCount = {}
                data?.map(pupil => {
                    const status = pupil?.[0]?.status
                    const statusId = status?.id
                    if (statusId < 0) {
                        if (finalCount[statusId]) {
                            finalCount[statusId].count += 1
                        } else {
                            finalCount[statusId] = {status, count: 1}
                        }
                    }
                })
                return finalCount;
            }

        },
        prepareItems(finalCount) {
            const pupilsCount = this.pupils?.length
            let finalObject = []
            let countStatuses = 0

            if (finalCount) {
                const finalCountArray = Object.values(finalCount)
                finalObject = finalCountArray.map(obj => {
                    countStatuses += obj.count
                    return {
                        color: obj.status.color,
                        text: obj.count,
                        description: `${obj.count} :${obj.status.hebrewName} `,
                        value: obj.count / pupilsCount * 100
                    }
                })
            }

            finalObject.push(
                {
                    color: 'rgb(0, 255, 132)',
                    text: pupilsCount - countStatuses,

                    description: `${pupilsCount - countStatuses} :נוכחים `,
                    value: (pupilsCount - countStatuses) / pupilsCount * 100
                }
            )
            return finalObject
        }
    },
    computed: {
        counts: {
            cache: false,
            get () {
                this.pupilCounts = null
                const finalCount = this.getFinalCount(this.dataObj)

                const finalObject = this.prepareItems(finalCount)
                this.pupilCounts = finalObject
                return finalObject
            }
        }

    },
    data() {
        return {
            pupilCounts: null
        }
    },
}
</script>

<style scoped>

</style>